import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change } from 'redux-form'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard, RowFields } from 'components'
import { 
  typeOfBondOptions,
  referenceDocumentOptions,
  referenceOriginalOptions
} from '../../AttributeData'
import { Cont } from './styled'

const BankGuaranteeInformation = (props) => {

  const { 
    change,
    valueForm,
    // props
    isEdit = false
  } = props

  const calculatePeriodDay = (dueDate) => {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(valueForm.startDate);
    const secondDate = new Date(dueDate);
    const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
    return diffDays
  }

  const checkDueDate = (dueDate) => {
    const firstDate = new Date(valueForm.startDate);
    const secondDate = new Date(dueDate);
    return firstDate<secondDate
  }

  const checkEdit01 = () => {
    if(valueForm.requestType=='new'){
      return isEdit
    }else if(valueForm.requestType=='extend'){
      return isEdit&&!valueForm.isReferenceOriginal
    }
  }

  return (
    <StdCard title={<span className='stepTitle'>Bank Guarantee Information</span>}>
      <Cont>
        <RowFields>
          <Field 
            name="typeOfBond"
            label="Type of Bond"
            component={FieldInput}
            options={typeOfBondOptions}
            type={type.select}
            editable={isEdit&&(valueForm.requestType=='new')}
            className='halfRow'
            specialOnChange={(value)=>{
              if(value!='other'){
                //clear typeOfBondOther
                change('formBGCompanyRequest','typeOfBondOther','')
              }
            }}
            require
          />
          {valueForm.typeOfBond=='other'?
          <Field 
            name="typeOfBondOther"
            label="Other"
            component={FieldInput}
            type={type.text}
            editable={isEdit&&(valueForm.requestType=='new')}
            require
          />:null}
        </RowFields>
        <RowFields>
          <Field 
            name="amount"
            label="Amount"
            component={FieldInput}
            type={type.number}
            editable={isEdit&&(valueForm.requestType=='new')}
            className='halfRow'
            allowNegative={false}
            require
          />
        </RowFields>
        <RowFields>
          <RowFields>
            <Field 
              name="startDate"
              label="Start Date"
              component={FieldInput}
              type={type.date}
              editable={isEdit}
              require
            />
            <Field 
              name="dueDate"
              label="Due Date"
              component={FieldInput}
              type={type.date}
              editable={isEdit&&!valueForm.isNoExpireDate}
              specialOnChange={(value)=>{
                if(value){
                  if(checkDueDate(value)){
                    change('formBGCompanyRequest','periodDay',calculatePeriodDay(value))
                  }else{
                    change('formBGCompanyRequest','dueDate','')
                  }
                }
              }}
              require={!valueForm.isNoExpireDate}
            />
          </RowFields>
          <RowFields>
            <Field 
              name="isNoExpireDate"
              label="No Expire Date"
              component={FieldInput}
              type={type.checkbox}
              editable={isEdit}
              fieldInputStyle={{justifyContent:'center'}}
              specialOnChange={(value)=>{
                if(value){
                  change('formBGCompanyRequest','dueDate','')
                  change('formBGCompanyRequest','periodDay','')
                }
              }}
            />
            <Field 
              name="periodDay"
              label="Period (Day)"
              component={FieldInput}
              type={type.number}
              editable={false}
            />
          </RowFields>
        </RowFields>
        <RowFields>
          <Field 
            name="expectReceiveDate"
            label="Expect Received Date"
            component={FieldInput}
            type={type.date}
            editable={isEdit}
            className='halfRow'
            require
          />
        </RowFields>
        {valueForm.requestType=='extend'?
        <RowFields>
          <Field 
            name='isReferenceOriginal' 
            label='Reference Document' 
            type={type.radio}
            options={referenceOriginalOptions}
            containerStyle={{ marginLeft: '10px' }}
            style={{ marginBottom: '0px' }}
            editable={isEdit}
            horizontalView
            component={FieldInput} />
        </RowFields>:null}
        <RowFields>
          <Field 
            name="referenceDocumentType"
            label="Original Reference Document"
            component={FieldInput}
            options={referenceDocumentOptions}
            type={type.select}
            editable={checkEdit01()}
            className='halfRow'
            specialOnChange={(value)=>{
              if(value){
                if(value=='contract'){
                  //clear file type bgc02
                  change('formBGCompanyRequest','bgc02','')
                }else if(value=='poNumber'){
                  //clear file type bgc01
                  change('formBGCompanyRequest','bgc01','')
                }
              }
            }}
            require
          />
        </RowFields>
        <RowFields>
          {valueForm.referenceDocumentType=='contract'?
          <React.Fragment>
            <Field 
              name="referenceContractDate"
              label="Contract Date"
              component={FieldInput}
              type={type.date}
              editable={checkEdit01()}
              require
            />
            <Field 
              name="referenceContractNumber"
              label="Contract Number"
              component={FieldInput}
              type={type.text}
              editable={checkEdit01()}
            />
          </React.Fragment>
          :
          <Field 
            name="referencePurchaseOrderNumber"
            label="Purchase Order Number"
            component={FieldInput}
            type={type.text}
            editable={checkEdit01()}
            className='halfRow'
            require
          />
          }
        </RowFields>
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formBGCompanyRequest')(state) || {},
  }
}

const mapDispatchToProps = {
  change
}

export default connect(mapStateToProps, mapDispatchToProps)(BankGuaranteeInformation)
